var _createForOfIteratorHelper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _require = require('orange-svg'),
  OrangeSVGLine = _require.OrangeSVGLine,
  OrangeSVGText = _require.OrangeSVGText;
var OrangeChartAxis = /*#__PURE__*/function () {
  "use strict";

  /**
   *
   * @param {string} axis
   */
  function OrangeChartAxis(axis) {
    _classCallCheck(this, OrangeChartAxis);
    this.axis = axis;
    this._config = {
      'sources': [],
      'lines': false,
      'label': false,
      'cumulative': axis === 'z',
      'dynamic': axis !== 'x',
      'color': false,
      'min': null,
      'max': null
    };
  }

  /**
   *
   * @param {object} config Config, "source" property defines one property for values, "sources" - multiple
   * @param {object[]} data Chart's data
   */
  _createClass(OrangeChartAxis, [{
    key: "update",
    value: function update(config, data) {
      var sources;
      if (config.hasOwnProperty('sources')) {
        sources = config.sources;
      } else if (config.hasOwnProperty('source')) {
        sources = [config.source];
      } else {
        sources = [];
      }
      Object.assign(this._config, config, {
        sources: sources
      });
      this._data = data;
    }

    /**
     * Name of the first property used as data source
     *
     * @type {?string}
     */
  }, {
    key: "source",
    get: function get() {
      return this._config.sources.length ? this._config.sources[0] : null;
    }

    /**
     *
     * @param {function(number, number): number} comparison_function
     * @return {number|null}
     * @private
     */
  }, {
    key: "_getSomethingFromData",
    value: function _getSomethingFromData(comparison_function) {
      var _this = this;
      var v = null;
      var tmp;
      var _iterator = _createForOfIteratorHelper(this._data),
        _step;
      try {
        var _loop = function _loop() {
          var row = _step.value;
          if (_this._config.cumulative) {
            tmp = _this._config.sources.reduce(function (a, c) {
              return a + row[c];
            }, 0);
            v = v === null ? tmp : comparison_function(tmp, v);
          } else {
            var _iterator2 = _createForOfIteratorHelper(_this._config.sources),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var source = _step2.value;
                v = v === null ? row[source] : comparison_function(row[source], v);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return v;
    }

    /**
     * Returns maximal value for the axis
     * @return {number}
     */
  }, {
    key: "getMaxFromData",
    value: function getMaxFromData() {
      return this._getSomethingFromData(Math.max);
    }

    /**
     * Returns minimal value for the axis
     * @return {number}
     */
  }, {
    key: "getMinFromData",
    value: function getMinFromData() {
      return this._getSomethingFromData(Math.min);
    }

    /**
     * Returns offsets for axis rendering
     *
     * @param view
     * @return {*}
     */
  }, {
    key: "getOffsets",
    value: function getOffsets(view) {
      var default_margin = view.hasOwnProperty('default_margin') ? view.default_margin : 10;
      if (this._config.label) {
        if (this.axis === 'x') {
          var y2m = this._config.title ? 6 : 3;
          return {
            'x1': 4 * default_margin,
            'x2': 4 * default_margin,
            'y2': y2m * default_margin
          };
        } else if (this.axis === 'y') {
          return {
            'x1': 8 * default_margin,
            'y1': default_margin,
            'y2': default_margin
          };
        }
      }
      return {};
    }

    /**
     * Minimal and maximal value for the axis
     *
     * @type {{min: number|null, max: number|null}|null}
     */
  }, {
    key: "scale",
    get: function get() {
      if (!this._config.sources.length) {
        return null;
      }
      var min = this._config.min;
      var max = this._config.max;
      if (min === null) {
        min = this._config.dynamic ? this.getMinFromData() : 0;
      }
      if (max === null) {
        max = this._config.dynamic ? this.getMaxFromData() : this._data.length - 1;
      }
      return {
        min: min,
        max: max
      };
    }

    /**
     *
     * @param {OrangeSVG} svg
     * @param {string} label
     * @param {number} x
     * @param {number} y
     * @param {string} anchor
     * @private
     */
  }, {
    key: "dynamic",
    get:
    /**
     * Returns if axis is supposed to be dynamic
     *
     * @return {boolean}
     */
    function get() {
      return !!this._config.dynamic;
    }

    /**
     * Returns if values used for the axis is cumulative
     *
     * @return {boolean}
     */
  }, {
    key: "cumulative",
    get: function get() {
      return !!this._config.cumulative;
    }

    /**
     * Axis color
     *
     * @type {string}
     */
  }, {
    key: "render",
    value:
    /**
     * Render axis
     *
     * @param {OrangeSVG} svg
     * @param {object} view
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @param {null|function(number, number, object): number} label_position_function
     */
    function render(svg, view, x1, y1, x2, y2) {
      var label_position_function = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
      var n = this._config.dynamic ? 11 : this._data.length; // TODO What if too much rows...
      var scale = this.scale;
      if (!scale) {
        throw new Error("Source for axis \"".concat(this.axis, "\" is not defined"));
      }
      var thickness = view.hasOwnProperty('line_thickness') ? view.line_thickness : null;
      var color = view.hasOwnProperty('line_color') ? view.line_color : this.constructor.COLOR;
      var default_margin = view.hasOwnProperty('default_margin') ? view.default_margin : 10;
      var is_vertical = this.axis === 'y';
      var size = is_vertical ? y2 - y1 : x2 - x1;
      var length = is_vertical ? x2 - x1 : y2 - y1;
      var margin = size / (n - 1);
      var position, label_text;
      var p = scale.min !== null && scale.max !== null ? this.constructor._p(scale.min, scale.max, n) : -1;
      var show_every_n = n > 21 ? Math.floor((n - 1) / 10) : 1;
      for (var i = 0; i < n; i++) {
        if (i % show_every_n) continue;
        position = i * margin;
        if (this._config.lines) {
          var line = new OrangeSVGLine((is_vertical ? 0 : position) + x1, (is_vertical ? position : 0) + y1, (is_vertical ? length : position) + x1, (is_vertical ? position : length) + y1, color, thickness);
          line.args = {
            'class': "orange-chart-scale orange-chart-scale-".concat(this.axis)
          };
          svg.appendChild(line);
        }
        if (this._config.label) {
          var _label_text = void 0;
          if (this._config.dynamic) {
            var format_function = function format_function(lt) {
              return p + 1 > 0 ? lt.toFixed(p + 1) : Math.round(lt).toString();
            };
            var range = scale.max - scale.min;
            var v = void 0;
            var real_n = n - 1;
            if (this._config.log) {
              if (is_vertical) {
                v = real_n !== i ? Math.pow(Math.E, (real_n - i) / real_n * Math.log(range)) : 0;
              } else {
                v = i ? Math.pow(Math.E, i / real_n * Math.log(range)) : 0;
              }
            } else {
              v = (is_vertical ? real_n - i : i) / real_n * range;
            }
            _label_text = format_function(v + scale.min);
          } else {
            _label_text = this._data[i][this._config.sources[0]];
          }
          this.constructor._addLabel(svg, typeof this._config.label === 'function' ? this._config.label(_label_text) : _label_text, (is_vertical ? -1 * default_margin : label_position_function ? label_position_function(i, size, view) : position) + x1, (is_vertical ? (label_position_function ? label_position_function(i, size, view) : position) + 0.5 * default_margin : length + 2.25 * default_margin) + y1, is_vertical ? 'end' : 'middle');
        }
      }
      if (this._config.title) {
        var text;
        if (this.axis === 'x') {
          text = new OrangeSVGText(this._config.title, x1 + (x2 - x1) / 2, y2 + 5 * default_margin, 'middle');
          text.args = {
            'class': 'orange-chart-axis-title'
          };
        } else {
          var ax = x1 - 6 * default_margin;
          var ay = y1 + (y2 - y1) / 2;
          text = new OrangeSVGText(this._config.title, ax, ay, 'middle');
          text.args = {
            'class': 'orange-chart-axis-title',
            'transform': "rotate(-90 ".concat(ax, ",").concat(ay, ")")
          };
        }
        svg.appendChild(text);
      }
    }
  }], [{
    key: "_addLabel",
    value: function _addLabel(svg, label, x, y) {
      var anchor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'middle';
      var text = new OrangeSVGText(label, x, y, anchor);
      text.args = {
        'class': 'orange-chart-label'
      };
      svg.appendChild(text);
    }
  }, {
    key: "COLOR",
    get: function get() {
      return this._color || 'rgba(127,127,127,0.2)';
    }

    /**
     * Axis color
     *
     * @type {string}
     */,
    set: function set(value) {
      this._color = value;
    }

    /**
     *
     * @param {number} min
     * @param {number} max
     * @param {number} n
     * @return {number}
     * @private
     */
  }, {
    key: "_p",
    value: function _p(min, max, n) {
      if (min === max) return -1;
      var p = Math.round(Math.log((max - min) / (n - 1)) / Math.log(10)) * -1;
      return Math.min(p, 99);
    }
  }]);
  return OrangeChartAxis;
}();
module.exports = OrangeChartAxis;